module.exports = __webpack_public_path__ + "img/goodtest.ad6e9e7e.jpg";